"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _i18n = require("@onviobr/services/i18n");

var _enUs = _interopRequireDefault(require("./en-us"));

var _esAr = _interopRequireDefault(require("./es-ar"));

var _frCa = _interopRequireDefault(require("./fr-ca"));

var _ptBr = _interopRequireDefault(require("./pt-br"));

var _default = function _default() {
  (0, _i18n.addKeys)(_enUs.default, 'en-US');
  (0, _i18n.addKeys)(_esAr.default, 'es-AR');
  (0, _i18n.addKeys)(_frCa.default, 'fr-CA');
  (0, _i18n.addKeys)(_ptBr.default, 'pt-BR');
};

exports.default = _default;
